import React from 'react';
import DefaultImg from "assets/img/formation_back.jpg";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import NotesIcon from '@mui/icons-material/Notes';
import YouTubeIcon from '@mui/icons-material/YouTube';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import { useNavigate} from "react-router-dom";
import {DEFAULT_BACKEND_URL} from "../../helpers/env";

function FormationCard(props) {

    const navigate = useNavigate();

  function typeToIcon(type) {
    switch (type) {
      case "video":
        return <YouTubeIcon/>;
      case "audio":
        return <AudioFileIcon/>;
      case "text":
        return <NotesIcon/>;
    case "document":
        return <PictureAsPdfIcon/>;
    }
  }
  const getYoutubeLink = (links) => {
    const splits = links.split("/");
    const vidId = splits[splits.length - 1];
    return `https://youtube.com/embed/${vidId}`;
};
  const image = props.image && props.image.length > 0 ? `${DEFAULT_BACKEND_URL}/formation/`+props.image : DefaultImg;

  function goTo(link){
    navigate("/formations/"+link);
  }

  return (
      <div className=" shadow flex flex-col" onClick={()=> {
          goTo(props.slug);
          props.selectFormation();
      }} style={{ cursor:"pointer" }}>
        <div className={"bg-green-200 flex items-center justify-center"} style={{ maxHeight:"180px",height:"180px" }}>
          {props.type!=="video" ?  <img src={image} className="h-full" style={{ margin:'0px',width:"100%",objectFit:"cover" }} crossOrigin={"anonymous"} alt={props.title}/> 
          : (props.links && props.links.length > 0 ? 
            <iframe width="100%" height="180" src={getYoutubeLink(props.links)} title="Agriculture au Bénin : vers une production régionale" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
            : <img src={image} className="h-full" style={{ margin:'0px',width:"100%",objectFit:"cover" }} crossOrigin={"anonymous"} alt={props.title}/> 
            )
          }
          </div>
        <div className="px-3">
          <h1 className={"mt-2"}>{props.title}</h1>
          <div className="flex items-center gap-3">
            <div className="rounded-lg px-1 py-1">{typeToIcon(props.type)}</div>
            <div className="rounded-lg bg-green-100 font-semibold px-2 py-1">{props.thematic?.name}</div>
          </div>
        </div>
      </div>
  );
}

export default FormationCard;